import { getDefaultClient } from '../../../client/defaultClient';
import { assertDefined } from '../../../utils/assertDefined';
import type { Chain } from '../../chain/chain.types';
import { userHasEmbeddedWalletForChain } from '../../wallets/userHasEmbeddedWalletForChain';
import { isDynamicWaasEnabled } from '../isDynamicWaasEnabled';

/**
 * Gets all chains missing a waas wallet account for the current user.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns An array of all chains that have waas wallet accounts enabled
 * but for which the current user does not yet have an embedded wallet account.
 */
export const getChainsMissingWaasWalletAccounts = (
  client = getDefaultClient()
): Chain[] => {
  const projectSettings = client.projectSettings;

  assertDefined(projectSettings, 'Project settings are not available');

  const embeddedWalletSettings = projectSettings.sdk.embeddedWallets;

  const isWaasEnabled = isDynamicWaasEnabled(client);

  const user = client.user;

  if (!user || !isWaasEnabled) {
    return [];
  }

  const enabledChainForWaas: Chain[] = (
    embeddedWalletSettings?.chainConfigurations?.filter(
      (chain) => chain.enabled
    ) ?? []
  ).map((chain) => chain.name as Chain);

  // For each enabled chain, if user does NOT have an embedded wallet, add to missing
  return enabledChainForWaas.filter(
    (chain) => !userHasEmbeddedWalletForChain({ chain, user })
  );
};
